import { SiteViewAssetVizPanel } from 'features/overview/components/assetVizPanel/SiteViewAssetVizPanel'
import { useSiteViewContext } from 'features/overview/state/SiteViewContext'
import React, { FC } from 'react'
import styled from 'styled-components'

const BottomContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: right;
  align-items: end;
  gap: 16px;
  margin: 16px;
`

interface SiteViewBottomOverlaysProps {
  mapAddMenuPositionRef: React.RefObject<HTMLDivElement>
  siteID: string
  orgID: string | undefined
  useAssetLifecycle: boolean
}
export const SiteViewBottomOverlays: FC<SiteViewBottomOverlaysProps> = (
  props
) => {
  const { selectedAssetModel, selectedComponent, selectedCDF } =
    useSiteViewContext()

  return (
    <BottomContainer>
      {selectedAssetModel && selectedComponent && selectedCDF && (
        <SiteViewAssetVizPanel
          selectedAssetModel={selectedAssetModel}
          selectedComponent={selectedComponent}
          selectedCDF={selectedCDF}
          siteID={props.siteID}
          orgID={props.orgID}
          useAssetLifecycle={props.useAssetLifecycle}
        />
      )}
      <div
        id={'site-view-map-add-menu-position-visual-container'}
        ref={props.mapAddMenuPositionRef}
      />
    </BottomContainer>
  )
}
